import styles from "../../styles/common/FormSubmitValidation.module.scss"
import {IcnCheckVerified, IcnCircleHelp, IcnInfoOctogone, IcnTriangleWarning} from "../../assets/icons";

import {ReactNode} from "react";
import clsx from "clsx";

import {cStatusProps} from "../../utils";

interface FormSubmitValidationProps extends cStatusProps {
  children: ReactNode;
  icon?: ReactNode;
}

function FormSubmitValidation(
  {
    type = "success",
    children,
    icon,
  }:FormSubmitValidationProps) {
  const typeIcons = {
    success: <IcnCheckVerified />,
    danger: <IcnTriangleWarning />,
    info: <IcnCircleHelp />,
    warning: <IcnInfoOctogone />,
    default: null
  };

  const displayIcon = icon !== undefined
    ? icon
    : typeIcons[type] || typeIcons.default;

  return (
    <div
      className={clsx(styles.cFormSubmitValidation, "c-form-submit-validation")}
      data-status-type={type}
    >
       {displayIcon && (
        <i>
          {displayIcon}
        </i>
      )}

      <div className="c-form-submit-validation-content">
        {children}
      </div>

    </div>
  );
}

export default FormSubmitValidation;